const WarNames = 
{
    HybridWar: "Hybrid War",
    WarOverCulture: "War Over Culture",
    WarOverTechnology: "War Over Technology",
    WarOverTerritory: "War Over Territory",
}

module.exports = WarNames;